import {useContext} from "react";
import {AnalyzeContextState, IAnalyzeContext} from "../context/AnalyzeContext";

export const useAnalyze = () => useContext<AnalyzeContextState>(IAnalyzeContext)
